import { Space } from 'antd';
import { type Map } from 'ol';
import styled from 'styled-components';
import { type IMapWidget } from '../../IMapWidget.ts';
import { MapLayersToggleControl } from './MapLayersToggleControl.tsx';
import { MapMousePositionControl } from './MapMousePositionControl.tsx';
import { MapZoomIndicator } from './MapZoomIndicator.tsx';

const ControlsWrapper = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 0.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 0.5rem;
`;

interface Props {
  map: React.RefObject<Map>;
  widget: IMapWidget;
}

export function MapControls(props: Props) {
  const { map, widget } = props;

  return (
    <ControlsWrapper>
      <MapLayersToggleControl map={map} widget={widget} />
      <Space>
        <MapZoomIndicator map={map} />
        <MapMousePositionControl map={map} />
      </Space>
    </ControlsWrapper>
  );
}
